import {SIGNMODAL_TYPE} from '../actions/types';

const INITIAL_STATE = {
  modal: false,
  title: '',
  describe: '',
  btntext: '',
  cancletext: 'انصراف',
  func: '',
};

const SignModal = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SIGNMODAL_TYPE:
      return {
        ...state,
        modal: action.payload.modal,
        title: action.payload.title,
        describe: action.payload.describe,
        btntext: action.payload.btntext,
        func: action.payload.func,
        cancletext: action.payload.cancletext,
      };
    default:
      return state;
  }
};

export default SignModal;
